import { useQuery } from "@tanstack/react-query";

import { requireData } from "../../shared/api/api-error.js";
import { useApi } from "../../shared/api/api-context.js";
import { isVisiblePosition, positionView, type PositionView } from "./models.js";

export const positionKeys = { all: ["positions"] as const };

export function usePositions() {
  const api = useApi();
  return useQuery({
    queryKey: positionKeys.all,
    queryFn: async ({ signal }) => {
      const visible: PositionView[] = [];
      const seenCursors = new Set<string>();
      let cursor: string | undefined;
      while (true) {
        const page = requireData(
          await api.GET("/positions", {
            params: { query: { limit: 100, ...(cursor === undefined ? {} : { cursor }) } },
            signal,
          }),
        );
        visible.push(...page.items.map((item) => positionView(item)).filter(isVisiblePosition));
        if (page.nextCursor === undefined) return visible;
        if (seenCursors.has(page.nextCursor)) {
          throw new Error("TradingEngine returned a repeated position page cursor.");
        }
        seenCursors.add(page.nextCursor);
        cursor = page.nextCursor;
      }
    },
    refetchInterval: 30_000,
  });
}
